// extracted by mini-css-extract-plugin
export default {"main":"card-edit_main__Czxgl","btnSection":"card-edit_btnSection__7eIKD","img":"card-edit_img__10u2W"};